import axios from "axios";
import { apiHost } from "../api/apiClient";

export const here_api_key = "qn1ywm2j3xqGlxzovg3yewF5HIX3We345ymi1UY_FP4";

export async function searchSuggestionAPI(query) {
    try {
        const response = await axios.get(`https://autocomplete.search.hereapi.com/v1/autocomplete?apiKey=${here_api_key}&q=${query}`);
        console.log("autocomplete api response", response.data.items);
        return response.data.items;
    } catch (e) {
        console.error(e);
        if (e.response.status == "401") {
            this.props.history.push("/login");
        }
    }
};

export async function GeoCodeAPI(searchText) {
    try {
        const response = await axios.get(`https://geocode.search.hereapi.com/v1/geocode?apiKey=${here_api_key}&q=${searchText}&lang=en-US`);
        console.log("reverseGeoCode", response.data.items);
        let lat = response.data.items[0].position?.lat;
        let lng = response.data.items[0].position?.lng;
        return { lat, lng };
    } catch (e) {
        console.error(e);
        if (e.response.status == "401") {
            this.props.history.push("/login");
        }
    }
};

export async function reverseGeoCodeAPI(lat, lng) {
    try {
        const response = await axios.get(`https://revgeocode.search.hereapi.com/v1/revgeocode?lang=en-US&apiKey=${here_api_key}&at=${lat},${lng}`);
        console.log("reverseGeoCode api response", response);
        return response.data.items[0].address.label;
    } catch (e) {
        console.error(e);
        if (e.response.status == "401") {
            this.props.history.push("/login");
        }
    }
};
export async function GetLocationAddress(lat,lng){
    try {
        const response = await axios.get(`${apiHost}/api/Assets/GetLocationAddress?Latitude=${lat}&Longitude=${lng}`,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            }
        );
        if (response.status =="200") {
            const location = response.data;
            return location;
        }
    } catch (e) {
        if (e.response.status == "401") {
            this.props.history.push("/login");
        } else {
            this.props.setErrorMessageAction(`${e}`);
        }
        console.log(`😱 Axios request failed: ${e}`);
    }
};